import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicantDocument } from 'src/app/models/screeningInvite';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { FileTransferPayload } from '../../models/FileTransferPayload';
import { ScreeningDraftService } from 'src/app/screening-module/services/screening-draft.service';

@Component({
  selector: 'app-applicant-documents',
  templateUrl: './applicant-documents.component.html',
  styleUrls: ['./applicant-documents.component.less']
})
export class ApplicantDocumentsComponent implements OnInit {

  @Input() documents: ApplicantDocument[];
  @Input() screeningId: number;
  @Input() inviteId: number;
  @Input() screeningDraftId: number;
  @Input() readOnly: boolean = false;
  @Input() hideHeader: boolean = false;
  fileLoaded: boolean;
  saving: boolean = false;
  fileTransfer: FileTransferPayload = new FileTransferPayload();
  constructor(private toast: ToastrService, private screening: ScreeningService, private fileDownload: FileDownloadService, public toastr: ToastrService, public drafts : ScreeningDraftService) { }

  ngOnInit() {
    // console.log('draft id ',this.screeningDraftId);
    // console.log('screeningId id ',this.screeningId);
  }

  public downloadFile(document: ApplicantDocument) {
    this.toast.info(`Downloading...`);
    this.screening.DownloadSupportingDoc(document.id).subscribe(res => {
      if (res) {
        this.fileDownload.HandleFileDownload(res, 'pdf', `${document.docName}`);
      } else {
        this.toast.error('Error downloading document!', '', { closeButton: true, disableTimeOut: true });
      }
    },
      error => {
        this.toast.error('Error downloading document!', '', { closeButton: true, disableTimeOut: true })
      });
  }

  public get applicantDocuments(): ApplicantDocument[] {
    if (!this.documents) return [];
    return this.documents;
  }

  public handleFileUploadForScreening(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.fileLoaded = false;
      reader.readAsDataURL(event.target.files[0]);
      // NOTE: ONCE the screening is saved, we need to attach the screeningId and reportNumber (invite id) to the file transfer object for saving on the BE!!
      reader.onload = (progressEvent: ProgressEvent) => {
        this.fileTransfer.base64FileString = (<FileReader>progressEvent.currentTarget).result.toString();
        this.fileLoaded = true;
        this.saving = true;
        if (this.fileTransfer.base64FileString) {
          this.fileTransfer.screeningId = this.screeningId;
          this.fileTransfer.inviteId = this.inviteId;
          this.fileTransfer.fileName = event.target.files[0].name;
          this.screening.UploadSupportingDoc(this.fileTransfer).subscribe((res: number) => {
            if (res === 0) {
              this.toastr.error('Error uploading supporting document. Please ensure the file is a PDF, PNG, JPG, or JPEG file.');
            }else
            {
              this.toastr.success('Document upload successful');
              this.screening.FetchSupportingDocsSummary(this.screeningId).subscribe(res => {
                this.documents = res;
              },
              err => {
                this.toast.error('Error fetching applicant documents.', '', { closeButton: true, disableTimeOut: true });
              });
            }
          },
            err => {
              this.toastr.error('Error uploading supporting document. Please ensure the file is a PDF, PNG, JPG, or JPEG file.');
              this.saving = false;
            },
            ()=>{ this.saving = false;});
        }
      }

    }
  }

  public handleFileUploadForDraft(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      this.fileLoaded = false;
      reader.readAsDataURL(event.target.files[0]);
      // NOTE: ONCE the screening is saved, we need to attach the screeningId and reportNumber (invite id) to the file transfer object for saving on the BE!!
      reader.onload = (progressEvent: ProgressEvent) => {
        this.fileTransfer.base64FileString = (<FileReader>progressEvent.currentTarget).result.toString();
        this.saving = true;
        this.fileLoaded = true;
        if (this.fileTransfer.base64FileString) {
          this.fileTransfer.screeningDraftId = this.screeningDraftId;
          this.fileTransfer.fileName = event.target.files[0].name;
          this.drafts.UploadSupportingDoc(this.fileTransfer).subscribe((res: number) => {
            if (res === 0) {
              this.toastr.error('Error uploading supporting document. Please ensure the file is a PDF, PNG, JPG, or JPEG file.');
            }else
            {
              this.toastr.success('Document upload successful');
              this.drafts.FetchSupportingDocsForDraft().subscribe(res => {
                this.documents = res;
                this.drafts.directOrderDemographics.docs = this.documents;
              },
              err => {
                this.toast.error('Error fetching applicant documents.', '', { closeButton: true, disableTimeOut: true });
              });
            }
          },
            err => {
              this.toastr.error('Error uploading supporting document. Please ensure the file is a PDF, PNG, JPG, or JPEG file.'),
              this.saving = false;
            },
            ()=>{ this.saving = false;});
        }
      }

    }
  }

}
